import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddResidualReportDialogComponent } from '../../../components/residuals/add-residual-report-dialog/add-residual-report-dialog.component';
import { ResidualPartner } from '../../../models/residuals/residualPartner';
import { User } from '../../../models/users/user';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-residuals-dashboard-page',
  templateUrl: './residuals-dashboard-page.component.html',
  standalone: false,
})
export class ResidualsDashboardPageComponent {
  selectedView = 'manage';

  onViewChange(event: any) {
    this.selectedView = event.target.value;
  }

  public namespace = 'residuals';

  /* MOCK DATA */
  partners = [
    new ResidualPartner({
      id: 'Propelled Brands',
      name: 'Propelled Brands',
      brands: ['Fast Signs', 'MY SALON SUITE'],
    }),
  ];

  agents = [
    new User({
      id: 'Michael Dahlheimer',
      firstName: 'Michael',
      lastName: 'Dahlheimer',
      emailAddress: 'michael.dahlheimer@gmail.com',
      accessBits: '',
      isDisabled: false,
      accessLevel: 1,
    }),
    new User({
      id: 'John Doe',
      firstName: 'John',
      lastName: 'Doe',
      emailAddress: 'john.doe@gmail.com',
      accessBits: '',
      isDisabled: false,
      accessLevel: 1,
    }),
  ];

  // partnerListItems = [
  //   new ListItem({id: 'Propelled Brands', name: 'Propelled Brands'}),
  // ]

  brands = [
    new ListItem({ id: 'Fast Signs', name: 'Fast Signs' }),
    new ListItem({ id: 'MY SALON SUITE', name: 'MY SALON SUITE' }),
  ];

  selectedBrandId: string | undefined;
  selectedPartnerId: string | undefined;
  selectedAgentId: string | undefined;

  selectedPartner: ResidualPartner | undefined;

  constructor(private dialog: MatDialog) {
    //this.selectedPartnerId = this.partners[0].id;
    //this.selectedBrand = this.brands[0];
    //this.selectedAgentId = this.agents[0].id;

    if (this.partners.length == 1) {
      this.selectedPartner = this.partners[0];
    }
  }

  onPartnerChange(event: any) {
    this.selectedPartner = this.partners.find(
      (partner) => partner.id === event.target.value,
    );
  }

  getPartnerListItems(): ListItem[] {
    return this.partners.map(
      (partner) => new ListItem({ id: partner.id, name: partner.name }),
    );
  }

  getAgentListItems(): ListItem[] {
    return this.agents.map(
      (agent) =>
        new ListItem({
          id: agent.id,
          name: agent.firstName + ' ' + agent.lastName,
        }),
    );
  }

  openAddResidualReportDialog() {
    const dialogRef = this.dialog.open(AddResidualReportDialogComponent, {
      autoFocus: true,
      restoreFocus: true,
      width: '400px',
      data: {
        brandId: this.selectedBrandId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  getBrandById(selectedBrandId: string | undefined): ListItem | undefined {
    return this.brands.find((brand) => brand.id === selectedBrandId);
  }
}
